import IndexConent from "../../../../src/pages/use-cases/page-content/agreements-and-contracts/sales-proposals-and-contracts.md";
import * as React from 'react';
export default {
  IndexConent,
  React
};